export const achievementData = {
  bio: "Achievements are more than just milestones; they represent dedication, resilience, and a continuous pursuit of excellence. Each accomplishment reflects a journey marked by problem-solving, innovation, and a strong commitment to personal and professional growth. The following highlights exemplify the values I bring to my work, the challenges I’ve embraced, and the results achieved through focused effort and collaboration.",
  achievements: [
    {
      id: 1,
      title: "Winner – CodeChef Campus Challenge",
      details:
        "Secured 1st place in a national-level coding competition organized by IIIT-Dharwad, outperforming 180+ participants with innovative algorithmic solutions.",
      date: "Aug 20, 2019",
      field: "Competitive Programming",
      image:
        "https://be-ui-uploads.s3.ap-south-1.amazonaws.com/production/63fd42eebdab28c344d2e422047730a3/ef3c3fd973ce6890b32d27be7a050b62.jpg",
    },
    {
      id: 2,
      title: "Hackathon Campus Ambassador – ISTE SC MANIT",
      details:
        "Chosen as Campus Ambassador for a national-level hackathon organized by ISTE SC MANIT-Bhopal, actively promoting and coordinating event participation.",
      date: "Sep 12, 2019",
      field: "Hackathon Leadership",
      image:
        "https://be-ui-uploads.s3.ap-south-1.amazonaws.com/production/2ac44f9e85c42ea7fea7124ac867abf1/cpd-product-marketing-alliance-best-practices-hackathon.jpg",
    },
    {
      id: 3,
      title: "Runner-Up – Algorithmic Design Competition",
      details:
        "Achieved runner-up position in a university-level algorithm competition by solving complex problems under timed conditions.",
      date: "Nov 03, 2019",
      field: "Data Structures & Algorithms",
      image:
        "https://images.unsplash.com/photo-1489389944381-3471b5b30f04?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80",
    },
  ],
};
